'use es6';

import SenderAvatar from '../sender-avatar/SenderAvatar';
import { AGENT, VISITOR } from 'conversations-message-history/constants/messageUses';
import SenderMap from 'conversations-message-history/proptypes/SenderMap';
import TypingDots from './TypingDots';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import PrimaryMessage from '../primary-message/components/PrimaryMessage';
import PrimaryMessageAvatar from '../primary-message/components/PrimaryMessageAvatar';
import PrimaryMessageContent from '../primary-message/components/PrimaryMessageContent';
import PrimaryMessageContentSection from '../primary-message/components/PrimaryMessageContentSection';
import PrimaryMessageHeader from '../primary-message/components/PrimaryMessageHeader';
import PrimaryMessageHeaderContent from '../primary-message/components/PrimaryMessageHeaderContent';
import TypingHeaderContent from './TypingHeaderContent';
import { announce } from 'visitor-ui-component-library/utils/aria-live/AriaLiveAnnouncer';
import { useEffect } from 'react';
import I18n from 'I18n';
import { getSenderFromMessageSenders } from '../common-message/operators/getSenderFromMessageSenders';
import { isFromVisitor } from 'conversations-message-history/common-message-format/operators/senderTypeComparators';
import { isSenderLoading } from 'conversations-message-history/senders/operators/isSenderLoading';
import { getFirstName } from 'conversations-message-history/senders/operators/getters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TypingIndicatorMessage = props => {
  const {
    message,
    senders
  } = props;
  const sender = getSenderFromMessageSenders(message, senders);
  const isLoading = isSenderLoading(sender);
  const senderName = getFirstName(sender);
  const isVisitor = isFromVisitor(message);
  const use = isVisitor ? VISITOR : AGENT;
  useEffect(() => {
    if (!isVisitor) {
      announce(I18n.text('conversations-visitor-message-history.subjectIsTyping', {
        subject: senderName || I18n.text('conversations-visitor-message-history.agent')
      }));
    }
  }, [isVisitor, senderName]);
  return /*#__PURE__*/_jsxs(PrimaryMessage, {
    use: use,
    children: [/*#__PURE__*/_jsxs(PrimaryMessageHeader, {
      children: [/*#__PURE__*/_jsx(PrimaryMessageAvatar, {
        children: /*#__PURE__*/_jsx(SenderAvatar, {
          sender: sender,
          isLoading: isLoading
        })
      }), /*#__PURE__*/_jsx(PrimaryMessageHeaderContent, {
        children: /*#__PURE__*/_jsx(TypingHeaderContent, {
          message: message,
          sender: sender,
          isSenderLoading: isLoading
        })
      })]
    }), /*#__PURE__*/_jsx(PrimaryMessageContent, {
      children: /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
        children: /*#__PURE__*/_jsx(TypingDots, {})
      })
    })]
  });
};
TypingIndicatorMessage.displayName = 'TypingIndicatorMessage';
TypingIndicatorMessage.propTypes = {
  message: RecordPropType('TypingIndicatorMessage').isRequired,
  senders: SenderMap.isRequired
};
export default TypingIndicatorMessage;